
class WhyTrustUs extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.why-trust-us-slider');
    this.boundResizeHandler = this.handleResize.bind(this);
    this.init();
  }

  static get constants() {
    return {
      MOBILE_BREAKPOINT: 989,
      DEFAULT_DESKTOP_COLUMNS: 4,
      DEFAULT_MOBILE_COLUMNS: 2,
      RESIZE_DEBOUNCE_MS: 250
    };
  }

  connectedCallback() {
    window.addEventListener('resize', this.debounce(this.boundResizeHandler, WhyTrustUs.constants.RESIZE_DEBOUNCE_MS));
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.boundResizeHandler);
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  init() {
    if (!this.slider) {
      console.warn('WhyTrustUs: Slider element not found');
      return;
    }

    const isMobile = window.innerWidth < WhyTrustUs.constants.MOBILE_BREAKPOINT;
    const isDesktopSliderEnabled = this.slider.dataset.slider === 'true';

    if (isMobile || isDesktopSliderEnabled) {
      this.initSwiper();
    }
  }

  handleResize() {
    const newIsMobile = window.innerWidth < WhyTrustUs.constants.MOBILE_BREAKPOINT;
    const isDesktopSliderEnabled = this.slider.dataset.slider === 'true';
    
    if (newIsMobile !== this.isMobile) {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      if (newIsMobile || isDesktopSliderEnabled) {
        this.initSwiper();
      }
    }
    this.isMobile = newIsMobile;
  }

  initSwiper() {
    try {
      const wrapper = this.slider.querySelector('.swiper-wrapper');
      if (!wrapper) {
        console.warn('WhyTrustUs: Swiper wrapper not found');
        return;
      }

      const desktopColumns = parseInt(wrapper.dataset.columns) || WhyTrustUs.constants.DEFAULT_DESKTOP_COLUMNS;
      const mobileColumns = parseInt(wrapper.dataset.mColumns) || WhyTrustUs.constants.DEFAULT_MOBILE_COLUMNS;

      const options = {
        spaceBetween: 8,
        watchOverflow: true,
        breakpoints: {
          0: {
            slidesPerView: Number(mobileColumns)
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 18
          },
          990: {
            slidesPerView: Number(desktopColumns),
            spaceBetween: 28
          }
        }
      };

      if (this.slider.dataset.arrow === 'true') {
        const nextButton = this.querySelector('.swiper-button-next');
        const prevButton = this.querySelector('.swiper-button-prev');
        
        if (nextButton && prevButton) {
          options.navigation = {
            nextEl: nextButton,
            prevEl: prevButton
          };
        }
      }

      if (this.slider.dataset.navigation === 'true') {
        const pagination = this.querySelector('.swiper-pagination');
        if (pagination) {
          options.pagination = {
            el: pagination,
            clickable: true
          };
        }
      }

      this.swiper = new Swiper(this.slider, options);
    } catch (error) {
      console.error('WhyTrustUs: Error initializing Swiper:', error);
    }
  }
}

customElements.define('why-trust-us', WhyTrustUs);